import ENABLE from '../../constants/enable';

//
// Data for email template
//
const email = process.env.EMAIL_SUPPORT || 'soporte@coltech.com.ar';
const emailCC1 = ENABLE.enableCuotitasCC ? (process.env.EMAIL_SUPPORT_CC1 || 'cuotaya.mesadeayuda@cuotaya.com.ar') : '';
const client = 'Cuota Ya';
const incidente = 'Incidente';
const criticidad = 'Criticidad';
const description = 'Descripción corta';
const contexto = 'Detalle aquí el paso a paso hasta llegar al problema. Adjunte captura del error de ser posible';
const product = 'FrontEnd de Originación';
const SO = navigator?.userAgentData?.platform || '';
const navigatorWeb = navigator?.userAgent || '';
const device = 'Cuando el incidente es en la Web de Firma, indique aquí Marca y Modelo del dispositivo usado en la firma';

//
// Get info about Browser
//
const getBrowserInfo = function () {
    var ua = navigator?.userAgent; var tem;
    var M = ua?.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
};

/**
 *
 * @param {*} data
 * @returns A tamplate for mail
 */
export function getTemplate (data) {
    const { store, fullname, date, dateTime } = data;
    const { idOfferExternal, idRequestExternal, idRequest, idSignRequest } = data;
    const { documentClient, fullnameClient, creditNumber, traceId } = data;
    const { errorCode, errorMessage } = data;

    const PLANTILLA_MAILTO = `mailto:${email}?
cc=${emailCC1}&
subject=[${client}]%20[${incidente}]%20[${criticidad}]%20[${description}]&
body=Contexto: ${contexto}%0A%0A
Reportado por: [${store}][${fullname}]%0A
Producto: [${product}]%0A
TraceId: [${traceId}]%0A
Fecha y hora: [${date}][${dateTime}]%0A
Código de Error: [${errorCode}]%0A
Mensaje de Error: [${errorMessage}]%0A
DNI Cliente: [${documentClient}]%0A
Nombre Cliente: [${fullnameClient}]%0A
Id oferta: [${idOfferExternal}]%0A
Id Solicitud: [${idRequestExternal}]%0A
Id de crédito: [${creditNumber}]%0A
Id de firma: [${idSignRequest}]%0A
Id operación: [${idRequest}]%0A
Características del SO: [${SO}],%20[${getBrowserInfo()}],%20[${navigatorWeb}]%0A%0A
Dispositivo: ${device}%0A%0A
`;
    return PLANTILLA_MAILTO;
}
